import { connect } from 'react-redux';
import { useSiteContext, useTranslation } from '@eti/providers';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { COMPREHENSIVE_INSURANCE_COVER_GENIUS } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = COMPREHENSIVE_INSURANCE_COVER_GENIUS;
const sharedTexts = {
  ipidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText',
  readMoreContent: 'comprehensiveInsuranceCoverGeniusAdditionalInformation',
  title: 'comprehensiveInsuranceCoverGeniusTitle'
};
const mainCardTranslations = {
  ...sharedTexts,
  abstractContent: 'comprehensiveInsuranceCoverGeniusAbstractText',
  upSell: 'comprehensiveInsuranceCoverGeniusUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'comprehensiveInsuranceCoverGeniusAbstractSmallCard',
    upSell: 'comprehensiveInsuranceCoverGeniusUpSellTextSmallCard'
  }
};
const ComprehensiveInsuranceCoverGenius = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    sellSpecification,
    productPosition,
    productSpecificTexts,
    layoutType = MAIN_CARD_LAYOUT
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    market
  } = useSiteContext();
  const texts = translations[layoutType] || {};
  const isInUSMarket = market.code === 'US';
  const isInUKMarket = market.code === 'GB';
  const {
    isSmallCardLayout,
    productData,
    rootElement,
    translation: {
      policyLinkText,
      ipidPolicyLinkText,
      readMoreContent,
      abstractContent
    }
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType
  });
  if (!productData) {
    return null;
  }
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: ipidPolicyLinkText
  };
  const coverGeniusTexts = {
    ipidPolicy,
    terms
  };
  const additionalInformationCoverGenius = isInUSMarket || isInUKMarket ? concatenateCoverGeniusTexts({
    disclaimer: !isSmallCardLayout && !isInUKMarket ? disclaimer : '',
    ...coverGeniusTexts,
    isInUSOrUKMarket: isInUSMarket || isInUKMarket,
    t,
    layoutType
  }) : '';
  const readMoreContentCoverGenius = concatenateCoverGeniusTexts({
    disclaimer: isInUSMarket ? '' : disclaimer,
    ...(!(isInUSMarket || isInUKMarket) ? coverGeniusTexts : {})
  });
  const coverGeniusLinks = isSmallCardLayout ? {
    description: `${abstractContent} ${additionalInformationCoverGenius}`
  } : {
    additionalInformation: additionalInformationCoverGenius
  };
  const updatedProductData = {
    ...productData,
    ...coverGeniusLinks,
    readMoreContent: readMoreContent + readMoreContentCoverGenius
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(COMPREHENSIVE_INSURANCE_COVER_GENIUS.name, form)(state)
  };
};
export default connect(mapStateToProps)(ComprehensiveInsuranceCoverGenius);
//# sourceMappingURL=ComprehensiveInsuranceCoverGenius.js.map